"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledSystem = require("styled-system");

var elevation = (0, _styledSystem.style)({
  prop: "elevation",
  cssProperty: "boxShadow",
  key: "elevations",
  transformValue: function transformValue(val, elevations) {
    return elevations[val];
  }
});
var _default = elevation;
exports["default"] = _default;